import type {
  ActivityItem,
  PhaseItem,
} from "../../../../pages/hid-admin/dashboard/partner-settings/technology-management/types";
import type { PhaseActivityApiItem, PhaseApiItem } from "./Types";

const mapActivityApiToUi = (activity: PhaseActivityApiItem): ActivityItem => ({
  id: String(activity.id),
  name: activity.activity_name,
  description: activity.description || "",
});

export const mapPhaseApiToUi = (phase: PhaseApiItem): PhaseItem => ({
  id: String(phase.id),
  order: phase.display_order,
  name: phase.phase_name,
  description: phase.description || "",
  activities: (phase.activities || []).map(mapActivityApiToUi),
});

export const mapPhasesApiToUi = (phases: PhaseApiItem[]): PhaseItem[] =>
  [...phases]
    .sort((a, b) => a.display_order - b.display_order)
    .map(mapPhaseApiToUi);
